import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { QuotationComponent } from '../../quotation/quotation.component';
import { ConfirmDeleteComponent } from './confirm-delete/confirm-delete.component';
import { Formality } from '../../../shared/models/quotation-model/catalogs/formality.model';
import { FormalityInsert } from '../../../shared/models/quotation-model/main/formality-insert.model';
import { QuotationFormalityAmount } from '../../../shared/models/quotation-model/main/quotation-formality-amount.model';
import { QuotationFormalityDelete } from '../../../shared/models/quotation-model/main/quotation-formality-delete.model';
import { QuotationFormalityUpdate } from '../../../shared/models/quotation-model/main/quotation-formality-update.model';
import { QuotationFormality } from '../../../shared/models/quotation-model/main/quotation-formality.model';
import { QuotationService } from '../../../shared/services/quotation/quotation.service';
import { MatSelect, MatLabel, MatFormField, MatOption } from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NgxMaskDirective } from 'ngx-mask';
import { MatTableModule } from '@angular/material/table';
import { MatIcon } from '@angular/material/icon';
import { QuotationFormalityService } from '../../../shared/services/quotation/quotation-formality-service';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-quotation-formality',
  templateUrl: './quotation-formality.component.html',
  styleUrls: ['./quotation-formality.component.scss'],
  standalone: true,
  imports: [
    MatSelect,
    MatLabel,
    MatFormField,
    MatOption,
    FormsModule,
    TranslateModule,
    NgxMaskDirective,
    MatTableModule,
    MatIcon,
    MatButtonModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
  ],
})
export class QuotationFormalityComponent implements OnInit {
  displayedColumns: string[] = ['Descripcion', 'Precio', 'Delete'];
  quotationFormalitys: QuotationFormality[] = [];
  formalitys: Formality[] = [];
  catalogFormalityId: any;
  formalityInsert!: FormalityInsert;
  quotationFormalityUpdate!: QuotationFormalityUpdate;
  formalitysCost: any[] = [];
  formalityDescription: any[] = [];
  quotationFormalityAmount!: QuotationFormalityAmount;
  totalFormality!: number;
  formalityDelete!: QuotationFormalityDelete;
  constructor(
    public dialogRef: MatDialogRef<QuotationComponent>,
    @Inject(MAT_DIALOG_DATA) public obj: any,
    private quotationFormalityService: QuotationFormalityService,
    private quotationService: QuotationService,
    public dialog: MatDialog,
  ) {}

  ngOnInit() {
    this.loadFormalitys();
    this.getQuotationFormalitys();
    this.loadQuotationFormalityAmount();
  }

  loadFormalitys() {
    this.quotationFormalityService.getFormalitys().subscribe((response) => {
      this.formalitys = response;
    });
  }

  createFormality() {
    this.formalityInsert = {
      quotationId: this.obj.quotationId,
      formalityId: this.catalogFormalityId,
    };
    this.quotationFormalityService.createFormality(this.formalityInsert).subscribe((response) => {
      this.loadFormalitys();
      this.getQuotationFormalitys();
    });
  }

  getQuotationFormalitys() {
    this.quotationService.getQuotationFormalitys(this.obj.quotationId).subscribe((response) => {
      this.quotationFormalitys = response;
      this.loadInputs(response);
    });
  }

  onChangeFormality(event: any) {
    this.catalogFormalityId = event.value;
  }

  updateFormalitys(element: QuotationFormality) {
    var formalityDescriptionData = '';
    if (
      element.formalitiesDescription === 'PLACAS Y DERECHOS' ||
      element.formalitiesDescription === 'VERIFICACION' ||
      element.formalitiesDescription === 'GESTORIA'
    ) {
      formalityDescriptionData = element.formalitiesDescription;
    } else {
      formalityDescriptionData = this.formalityDescription[element.id];
    }
    this.quotationFormalityUpdate = {
      quotationId: this.obj.quotationId,
      formalityId: element.id,
      formalityDescription: formalityDescriptionData,
      cost: this.formalitysCost[element.id],
    };
    this.quotationService.updateFormality(this.quotationFormalityUpdate).subscribe((response) => {
      this.getQuotationFormalitys();
      this.loadQuotationFormalityAmount();
    });
  }

  loadInputs(items: QuotationFormality[]) {
    items.forEach((item) => {
      this.formalitysCost[item.id] = item.cost;
      this.formalityDescription[item.id] = item.formalitiesDescription;
    });
  }

  loadQuotationFormalityAmount() {
    this.quotationFormalityAmount = { totalFormalities: 0, id: 0 };
    this.quotationFormalityService
      .getFormalityAmount(this.obj.quotationId)
      .subscribe((response) => {
        if (response != null) {
          this.quotationFormalityAmount = response;
          this.totalFormality = this.quotationFormalityAmount.totalFormalities;
        } else {
          this.quotationFormalityAmount = { totalFormalities: 0, id: 0 };
        }
      });
  }

  openDialogConfirm(element: QuotationFormality) {
    this.formalityDelete = { quotationId: this.obj.quotationId, formalityId: element.id };
    const dialogRef = this.dialog.open(ConfirmDeleteComponent, {
      width: '350px',
      data: { quotationId: this.obj.quotationId, formalityId: element.id },
      panelClass: 'dialog-container-custom',
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.loadFormalitys();
      this.getQuotationFormalitys();
      this.loadQuotationFormalityAmount();
    });
  }

  public closeModal(): void {
    this.dialogRef.close(null);
  }

  public confirmAndCloseModal(): void {
    this.dialogRef.close(true);
  }
}
